import BFStatus from './bfStatusComponent';

export default BFStatus;
